import React from "react";
import { Paper, Typography } from "@mui/material";
import ReactMarkdownStyled from "../reactMarkdownStyled";

type Props = {
  markdown: string;
  currentStepTitle?: string;
};

export const FinalChunkRenderer: React.FC<Props> = ({ markdown, currentStepTitle }) => {
  if (!markdown.trim()) {
    return null;
  }


  return (
    <Paper
      elevation={3}
      sx={{
        mt: 4,
        p: 3,
        borderRadius: 2,
        backgroundColor: "background.paper",
        maxWidth: "100%",
        overflowX: "auto",
        "& pre": {
          backgroundColor: "neutral.100",
          borderRadius: 8,
          fontSize: 14,
          overflowX: "auto",
          padding: 2,
        },
        "& a": {
          color: "primary.main",
        },
        "& h1": { marginBottom: 1 },
        "& h2": { marginBottom: 1 },
        "& h3": { marginBottom: 1 },
        "& p": { marginBottom: 1 },
      }}
    >
      <Typography variant="h5" gutterBottom>
      {currentStepTitle ? currentStepTitle : ""}
                    </Typography>
    <ReactMarkdownStyled markdown={markdown} />
    </Paper>
  );
};